import { useSplitTreatments } from '@splitsoftware/splitio-react';
import { useEffect } from 'react';

import { FeatureFlags } from '~constants/featureFlags';

declare global {
  interface Window {
    __featureFlags__?: Record<string, string>;
  }
}

// Flags exposed to Playwright via `window.__featureFlags__`. Add to this list
// when a new e2e variant needs to skip on a treatment.
const TRACKED_FLAGS: FeatureFlags[] = [
  FeatureFlags.defaultVendorRateToDriver,
  FeatureFlags.dispatchSmartAutoRefresh,
  FeatureFlags.inAppMessaging,
  FeatureFlags.tomlinsonOrderModal,
  FeatureFlags.typedTruckCapacityV1,
];

const FeatureFlagsToWindow = () => {
  const { treatments, isReady } = useSplitTreatments({ names: TRACKED_FLAGS });

  useEffect(() => {
    if (!isReady) return;
    const snapshot: Record<string, string> = {};
    for (const flag of TRACKED_FLAGS) {
      snapshot[flag] = treatments[flag]?.treatment ?? 'control';
    }
    window.__featureFlags__ = snapshot;
  }, [isReady, treatments]);

  return null;
};

export default FeatureFlagsToWindow;
